import { HTMLElement, Node, isString } from "./types.js";
import { forEachOfArray } from "./array.js";
import { document, documentElement } from "./window.js";
import { parentElement } from "./create.js";
export const removeNode = (...elements) => forEachOfArray(elements, (el) => el?.remove());
/**
 * @deprecated
 */
export const remove = removeNode;
export const append = (element, ...children) => element.append(...children);
export const prepend = (element, ...children) => {
    element.prepend(...children);
};
export const after = (element, ...children) => {
    element.after(...children);
};
export const before = (element, ...children) => {
    element.before(...children);
};
export const replace = (element, ...children) => {
    element.replaceWith(...children);
};
export const importNode = (node) => document.importNode(node, true);
export const adoptNode = (node) => document.adoptNode(node);
export const cloneNode = (node) => node.cloneNode(true);
/**
 * @deprecated
 */
export const clone = cloneNode;
export const setAttribute = (element, qualifiedName, value) => element.setAttribute(qualifiedName, value);
export const hasAttribute = (element, name, value) => {
    const data = element.getAttribute(name);
    return value === undefined ? data !== null : data === value;
};
export const getAttribute = (element, name) => element.getAttribute(name);
export const removeAttribute = (element, name) => element.removeAttribute(name);
/**
 * @deprecated (use removeChildNodes)
 */
export const clear = (parentNode) => {
    setHtml(parentNode, "");
};
export const removeChildNodes = (parentNode) => {
    if (!parentNode)
        return;
    let child;
    while (child = parentNode.firstChild) {
        parentNode.removeChild(child);
    }
};
export const setText = (node, content) => {
    node.textContent = content;
};
export const setHtml = (parentNode, htmlString) => {
    parentNode.innerHTML = htmlString;
};
export const hasDataAttribute = (element, name, value) => {
    const data = element.dataset[name];
    return value === undefined ? data !== undefined : data === value;
};
export const getDataAttribute = (element, name) => element.dataset[name];
export const setDataAttribute = (element, name, value) => element.dataset[name] = value;
export const removeDataAttribute = (element, name) => delete element.dataset[name];
export const closestData = (target, name, callback, host = documentElement) => {
    while (target instanceof Node) {
        if (target instanceof HTMLElement) {
            const value = getDataAttribute(target, name);
            if (isString(value)) {
                callback?.(value, target);
                return value;
            }
        }
        target = parentElement(target);
        if (target == host) {
            break;
        }
    }
    return null;
};
export const hasId = (element, id) => {
    return element.id == id;
};
export const setId = (element, id) => {
    element.id = id;
};
export const getId = (element) => element.id;
/**
 * @deprecated
 */
export const text = setText;
